import { useGetDistances } from 'queries';

const useGetMaxCLASettingsTableData = () => {
  const { data, isFetching } = useGetDistances();

  return { data, isFetching };
};

export default useGetMaxCLASettingsTableData;
